import logo from "assets/images/benevv_logo.png";
import { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "store/store";
import App from "./App";
import "./index.css";
import reportWebVitals from "./misc/reportWebVitals";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <PersistGate loading={null} persistor={persistor}>
    <App />
  </PersistGate>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
